import { render, staticRenderFns } from "./InformeInventario.vue?vue&type=template&id=51796b0f&"
import script from "./InformeInventario.vue?vue&type=script&lang=js&"
export * from "./InformeInventario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports